/// <reference path="prototypes/p-string.ts" />

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, Location, HashLocationStrategy } from '@angular/common';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';

// activates
import {ActivateLogin} from './activates';
// resolvers
import {LoginResolver} from './resolvers';
// routes
import { AppRoutingModule } from './app.routing.module';

// Core
import { AppCoreModule } from './app.core.module';

@NgModule({
  declarations: [
    AppComponent,
	LoginComponent
  ],
  imports: [
    BrowserModule,
    AppCoreModule.forRoot(),
    AppRoutingModule
  ],
  providers: [
    ActivateLogin,
	LoginResolver,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/app.module.ts